import { memo, useState } from '../../../lib/teact/teact';

import { ApiMessageEntityTypes } from '../../../api/types';

import buildClassName from '../../../util/buildClassName';
import { getPrettyCodeLanguageName } from '../../../util/codeLanguages';

import useAsync from '../../../hooks/useAsync';
import useLang from '../../../hooks/useLang';
import useLastCallback from '../../../hooks/useLastCallback';

import PeerColorWrapper from '../PeerColorWrapper';
import CodeOverlay from './CodeOverlay';

import './CodeBlock.scss';

export type OwnProps = {
  text: string;
  language?: string;
  noCopy?: boolean;
  richQuoteIndex?: number;
};

const CodeBlock = ({ text, language, noCopy, richQuoteIndex }: OwnProps) => {
  const lang = useLang();

  const [isWordWrap, setIsWordWrap] = useState(true);

  const { result: highlighted } = useAsync(() => {
    if (!language) return Promise.resolve(undefined);
    return import('../../../util/highlightCode')
      .then((lib) => lib.default(text, language));
  }, [language, text]);

  const handleWordWrapToggle = useLastCallback((wrap) => {
    setIsWordWrap(wrap);
  });

  const blockClass = buildClassName(
    'code-block',
    !isWordWrap && 'no-word-wrap custom-scroll-x no-scrollbar',
  );

  return (
    <PeerColorWrapper
      className="CodeBlock"
    >
      {language && (<p className="code-title">{getPrettyCodeLanguageName(lang, language)}</p>)}
      <pre
        className={blockClass}
        data-entity-type={ApiMessageEntityTypes.Pre}
        data-language={language}
        data-rich-quote-index={richQuoteIndex}
      >
        {highlighted ?? text}
        <CodeOverlay
          text={text}
          className="code-overlay"
          onWordWrapToggle={handleWordWrapToggle}
          noCopy={noCopy}
        />
      </pre>
    </PeerColorWrapper>
  );
};

export default memo(CodeBlock);
